<template>
    <v-content>
        <!-- mobile view -->
        <v-navigation-drawer right dark dense transparent persistent v-model="drawer" enable-resize-watcher fixed app width="150" v-if="isMobile">
            <v-list dense>
                <v-divider></v-divider>
                <v-list-tile ripple @click="viewHelp">
                    <v-list-tile-content class="leftnav-content-text" >
                        <v-list-tile-title>Knowledge Hub</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile ripple>
                    <v-list-tile-content class="leftnav-content-text" @click="dialogContactUs=true">
                        <v-list-tile-title>Contact Us</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile to="/login" ripple>
                    <v-list-tile-content class="leftnav-content-text">
                        <v-list-tile-title>Login</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>

        <!-- desktop view -->
        <v-toolbar fixed flat clipped-right class="transparent">
            <img src="@/assets/logo/favicon200x200.png" alt="logo" @click="viewPortalSite">
            <h1 class="font-weight-light logotext" :style="isMobile?'color:white;':''" @click="viewPortalSite">Sweldo</h1>
            <h1 class="cyan--text font-weight-light logotext" @click="viewPortalSite">Now</h1>
            <h1 class="black--text font-weight-light logotext header-env">{{ environment }}</h1>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn flat :class="getLinkStyle('userguide')" @click="viewHelp">Knowledge Hub</v-btn>
                <v-btn flat :class="getLinkStyle('contact')" @click="dialogContactUs=true">Contact Us</v-btn>
                <v-btn flat to="/login" :class="getLinkStyle('login')">Login</v-btn>
            </v-toolbar-items>

            <!-- Mobile: Notification + Menu -->
            <v-toolbar-side-icon v-if="isMobile && notificationsCount > 0" @click="dialogNotifications=true">
                <v-badge overlap small color="#ffb38a">
                    <template v-slot:badge>
                        <span class="caption">{{notificationsCount}}</span>
                    </template>
                    <v-icon color="#ff6700">
                        notifications
                    </v-icon>
                </v-badge>
            </v-toolbar-side-icon>

             <v-toolbar-side-icon v-if="isMobile" class="grey--text" @click.stop="drawer = !drawer">
                <v-icon>menu</v-icon>
            </v-toolbar-side-icon>
        </v-toolbar>
        <v-dialog v-model="dialogContactUs" width="900" hide-overlay>   
            <contact-us :dialogContactUs.sync="dialogContactUs"></contact-us>
        </v-dialog>
        <v-dialog v-model="dialogNotifications" fullscreen hide-overlay transition="dialog-bottom-transition">   
            <v-card style="border-radius:4px;">
                <v-toolbar flat height="55px">
                    <span class="font-weight-bold">Announcements</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogNotifications=false" >
                        <v-icon >close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <public-notifications :dialogNotifications.sync="dialogNotifications"></public-notifications>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-content>
</template>
<script>

export default {
    data () {
        return {
            drawer: false,
            dialogContactUs: false,
            dialogUpgrade: false,
            dialogNotifications: false,
        }
    },   
    props: ['current_page'],
    components: {
        'contact-us': () => import('@/components/Common/ContactUs'),
        'public-notifications': () => import('@/components/PublicNotifications/PublicNotifications'),
    },
    methods: {
        getLinkStyle(page) {
            var header_style = "font-weight-regular white--text"
            
            if (this.current_page == page)
                header_style = "font-weight-bold white--text"

            return header_style
        },
        viewPortalSite() {
            window.open("https://www.sweldonow.ph")
        },
        viewHelp() {
            window.open("https://help.sweldonow.ph")
        },
    },
    mounted() {},
    computed: {
        environment() {
            if (window.location.href.toString().includes('localhost')) {
                return 'Local Environment'
            }else if (window.location.href.toString().includes('test')) {
                return 'Test Environment'
            }else{
                return ''
            }
        },
        notificationsCount() {
            const cachedData = localStorage.getItem('publicNotifications')
            if (cachedData) {
                return JSON.parse(cachedData).length
            }
            return 0
        }
    },
    created() {},
  }
</script>
<style>
img {
    height:30px;
    width:28px;
    margin-right:5px;
    cursor:pointer;
}
.logotext {
    font-family:Roboto;
    cursor:pointer;
    margin-top:10px;
}
.header-env {
    margin-left: 5px;
    font-style: italic;
}
</style>